<template>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition">
        <v-card tile>
            <v-card-title class="elevation-3">
                {{ $t('common.save_in_folder') }}
                <v-spacer></v-spacer>
                <v-icon @click="hide">mdi-close</v-icon>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-3">
                    <v-col cols="12" class="pb-0 title-section">
                        {{ $t('common.select_folder') }}
                    </v-col>
                    <v-col cols="12">
                        <div v-if="currentFolders.length === 0" class="mb-3">
                            {{ $t('common.no_folders') }}
                        </div>
                        <v-chip
                            class="mr-3 mb-3"
                            v-for="folder in currentFolders"
                            :key="folder.id" label link
                            @click="onSelectFolder(folder)"
                            :color="isActiveFolder(folder) ? 'secondary' : null"
                        >
                            <v-icon left>
                                {{ isActiveFolder(folder) ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
                            </v-icon>
                            {{ folder.name }}
                        </v-chip>
                        <v-divider/>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn depressed @click="hide" class="normal-btn">
                    {{ $t('common.cancel') }}
                </v-btn>
                <v-btn depressed color="primary" class="normal-btn black--text" :disabled="disabled"
                       @click="save" :loading="loading">
                    {{ $t('common.save') }}
                </v-btn>
            </v-card-actions>
        </v-card>

    </v-dialog>
</template>

<script>
import {db} from "@/utils/Firebase";
import {mapMutations, mapState, mapActions} from "vuex";

export default {
    name: "SaveInFolderDialog",
    props: {
        currentId: {
            type: String,
            default: null,
        },
        defaultFolder: {
            type: String,
            default: null,
        },
        type: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            dialog: false,
            loading: false,
            folder: null,
        }
    },
    computed: {
        ...mapState(['dialogActive', 'folders']),
        disabled(vm = this) {
            return (!vm.folder && !vm.defaultFolder) || vm.defaultFolder === vm.folder?.id
        },
        currentFolders(vm = this) {
            return vm.folders.filter(folder => folder.type === vm.type)
        },
    },
    async mounted() {
        const vm = this
        if (vm.folders.length === 0) await vm.bindFolders(vm.currentUser.uid)
        vm.setDefaults()
    },
    methods: {
        ...mapMutations(['setDialogActive']),
        ...mapActions(['bindFolders']),
        show() {
            const vm = this
            vm.dialog = true
            vm.setDialogActive(true)
        },
        hide() {
            const vm = this
            vm.dialog = false
            vm.setDialogActive(false)
            vm.reset()
        },
        reset() {
            const vm = this
            vm.folder = null
            vm.$emit('cancel')
        },
        onSelectFolder(folder) {
            const vm = this
            if(vm.folder?.id === folder?.id) return vm.folder = null
            vm.folder = folder
        },
        isActiveFolder(folder) {
            const vm = this
            return vm.folder?.id === folder.id
        },
        async save() {
            const vm = this
            vm.loading = true
            await db.collection(vm.type).doc(vm.currentId).update({folder: vm.folder?.id || null})
            vm.hide()
            vm.loading = false
            vm.toast(vm.$t('common.changes_saved'))
        },
        setDefaults() {
            const vm = this
            if(vm.defaultFolder) vm.folder = vm.currentFolders.find(folder => vm.defaultFolder === folder.id) || null
        }
    },
    watch: {
        dialogActive(val) {
            if (!val) this.hide()
        },
        defaultFolder() {
            this.setDefaults()
        }
    }
}
</script>

<style scoped>

.title-section {
    font-size: 15px;
    font-weight: bold;
}

</style>